import React from 'react';
import PropTypes from 'prop-types';

import IconSearch from '../../../../../images/icons/misc/search.svg';

import styles from './NoResults.module.scss';

const NoResults = ({ product }) =>
  (
    <React.Fragment>
      <span className={styles.desktop}>No search results</span>
      <div className={styles.mobile}>
        <span>
          <IconSearch />
        </span>
        <span>{`No ${product} events match your search`}</span>
      </div>
    </React.Fragment>
  );

NoResults.propTypes = {
  product: PropTypes.string.isRequired
};

export default NoResults;
